import { render, staticRenderFns } from "./CommutatorDetails.vue?vue&type=template&id=618fd7a4&scoped=true&"
import script from "./CommutatorDetails.vue?vue&type=script&lang=js&"
export * from "./CommutatorDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommutatorDetails.vue?vue&type=style&index=0&id=618fd7a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618fd7a4",
  null
  
)

export default component.exports